import ETH from "../img/ticker_icon/eth.svg";
import WETH from "../img/ticker_icon/weth.svg";
import DAI from "../img/ticker_icon/dai.svg";
import UNI from "../img/ticker_icon/uniswap.svg";
import USDC from "../img/ticker_icon/usdc.svg";
import WBTC from "../img/ticker_icon/wbtc.svg";
import MKR from "../img/ticker_icon/mkr.svg";
import LINK from "../img/ticker_icon/link.svg";
import FTM from "../img/ticker_icon/ftm.svg";
import CEL from "../img/ticker_icon/celsius.svg";
import ONEINCH from "../img/ticker_icon/1inch.svg";
import SAND from "../img/ticker_icon/sand.svg";
import YFI from "../img/ticker_icon/yfi.svg";
import SHIB from "../img/ticker_icon/shib.svg";
import USDP from "../img/ticker_icon/pax.svg";
import RENBTC from "../img/ticker_icon/renbtc.png";
import YGG from "../img/ticker_icon/ygg.png";
import UST from "../img/ticker_icon/ust.png";
import SUSHI from "../img/ticker_icon/sushi.svg";
import MATIC from "../img/ticker_icon/matic.svg";
import BAND from "../img/ticker_icon/band.svg";
import COMP from "../img/ticker_icon/comp.svg";
import CRV from "../img/ticker_icon/crv.svg";
import AAVE from "../img/ticker_icon/aave.svg";
import APE from "../img/ticker_icon/ape.svg";
import BAL from "../img/ticker_icon/bal.svg";
import BAT from "../img/ticker_icon/bat.svg";
import CRO from "../img/ticker_icon/cro.svg";
import ENS from "../img/ticker_icon/ens.svg";
import FTT from "../img/ticker_icon/ftt.svg";
import PERP from "../img/ticker_icon/perp.svg";
import MPL from "../img/ticker_icon/mpl.svg";
import MULTI from "../img/ticker_icon/multi.svg";
import OMG from "../img/ticker_icon/omg.svg";
import GRT from "../img/ticker_icon/grt.svg";
import LDO from "../img/ticker_icon/ldo.svg";
import IMX from "../img/ticker_icon/imx.svg";
import GALA from "../img/ticker_icon/gala.svg";
import AMP from "../img/ticker_icon/amp.svg";
import ZRX from "../img/ticker_icon/zrx.svg";
import BUSD from "../img/ticker_icon/busd.svg";
import TUSD from "../img/ticker_icon/tusd.svg";
import USDT from "../img/ticker_icon/usdt.svg";
import HFT from "../img/ticker_icon/hft.svg";
import BLUR from "../img/ticker_icon/blur.svg";
import CBETH from "../img/ticker_icon/cbETH.svg";
import DYDX from "../img/ticker_icon/dydx.svg";
import CTX from "../img/ticker_icon/ctx.svg";
import PEPE from "../img/ticker_icon/pepe.svg";
// Polygon
import WMATIC from "../img/ticker_icon/wmatic_token_icon.svg";
import { Token } from "../store/global/TokenEnum";

// Arb
import ARB from "../img/ticker_icon/arb.svg";
import GMX from "../img/ticker_icon/GMX.svg";
import MAGIC from "../img/ticker_icon/MAGIC.svg";
import RDNT from "../img/ticker_icon/RNDT.svg";
import FET from "../img/ticker_icon/FET.svg";
export const TOKEN_ICONS: Partial<Record<Token, string>> = {
  [Token.AAVE]: AAVE,
  [Token.AMP]: AMP,
  [Token.APE]: APE,
  [Token.BAL]: BAL,
  [Token.BAND]: BAND,
  [Token.BAT]: BAT,
  [Token.BLUR]: BLUR,
  [Token.BUSD]: BUSD,
  [Token.CBETH]: CBETH,
  [Token.CEL]: CEL,
  [Token.COMP]: COMP,
  [Token.CRO]: CRO,
  [Token.CRV]: CRV,
  [Token.CTX]: CTX,
  [Token.DAI]: DAI,
  [Token.DYDX]: DYDX,
  [Token.ENS]: ENS,
  [Token.ETH]: ETH,
  [Token.FET]: FET,
  [Token.FTM]: FTM,
  [Token.FTT]: FTT,
  [Token.GALA]: GALA,
  [Token.GMX]: GMX,
  [Token.GRT]: GRT,
  [Token.HFT]: HFT,
  [Token.IMX]: IMX,
  [Token.LDO]: LDO,
  [Token.LINK]: LINK,
  [Token.MAGIC]: MAGIC,
  [Token.MATIC]: MATIC,
  [Token.MKR]: MKR,
  [Token.MPL]: MPL,
  [Token.MULTI]: MULTI,
  [Token.OMG]: OMG,
  [Token.PERP]: PERP,
  [Token.PEPE]: PEPE,
  [Token.RDNT]: RDNT,
  [Token.RENBTC]: RENBTC,
  [Token.SAND]: SAND,
  [Token.SHIB]: SHIB,
  [Token.SUSHI]: SUSHI,
  [Token.TUSD]: TUSD,
  [Token.UNI]: UNI,
  [Token.USDC]: USDC,
  [Token.USDP]: USDP,
  [Token.UST]: UST,
  [Token.WBTC]: WBTC,
  [Token.WETH]: WETH,
  [Token.YFI]: YFI,
  [Token.YGG]: YGG,
  [Token.ZRX]: ZRX,
  [Token["1INCH"]]: ONEINCH,

  // polygon
  [Token.WMATIC]: WMATIC,
  [Token.USDT]: USDT,
  [Token.ARB]: ARB,
};
